import React, { useState } from "react";

import ImageManager from "components/molecures/ImageManager";
import Alubum, { Photo } from "components/molecures/Allbum";
import { Button, Dialog, DialogActions } from "@material-ui/core";
import { API, graphqlOperation } from "aws-amplify";
import { useTranslation } from "react-i18next";
import { getImage } from "graphql/queries";
import { useSelector } from "react-redux";
import {
  createAlbum,
  deleteAlbumPhot,
  createAlbumPhot,
} from "../../graphql/mutations";

const _uniqPhots = (phots: Photo[]) => {
  return phots
    .map((phot) => phot.id)
    .filter((val, i, self) => self.indexOf(val) === i)
    .map((uniqu_id) => {
      let tmp;
      phots.forEach((v, i) => {
        if (uniqu_id === v.id) {
          tmp = v;
        }
      });
      return tmp;
    });
};

type Props = {
  name: string;
  form: any;
  onChange: any;
  value: any;
};
const PhotoForm = (props: Props) => {
  const { value, onChange } = props;
  const [pictures, setPictures] = useState<Photo[]>([]); //登録中フォト
  const [selectedPhoto, setSelectedPhoto] = useState([]); //選択中フォト
  const [albumID, setAlbumID] = useState(null);
  const [oldAlbumPhots, setOldAlbumPhots] = useState<Photo[]>([]); //登録前(removeだと一括削除ができないようなので保持)
  const { t } = useTranslation();
  const show = useSelector((state: any) => state.user.selectedShow);

  const _addOwnerValue = (input: any) => {
    if (show) {
      input["owner"] = show.owner;
    }
    return input;
  };

  const _saveSelectedPhotoToAlbum = async (_pictures: any[]) => {
    let _albumID = albumID;
    if (_albumID || value) {
      if (!_albumID) {
        if (typeof value === "object" && "id" in value) {
          _albumID = value.id;
        } else {
          _albumID = value;
        }
      }
      // reset アルバムの紐付けを消す
      oldAlbumPhots.forEach(async (val, i) => {
        await API.graphql(
          // @ts-ignore
          graphqlOperation(deleteAlbumPhot, {
            input: {
              id: val.id,
              expectedVersion: val.version,
            },
          })
        );
      });
      setOldAlbumPhots([]);
    } else {
      const new_album = (await API.graphql(
        graphqlOperation(createAlbum, {
          input: _addOwnerValue({
            name: null, //この時点で目印データが何もない
          }),
        })
      )) as any;
      _albumID = new_album.data.createAlbum.id;
    }

    let _oldAlbumPhots: any[] = [];
    // let _inputcreateAlbumPhot: any = {};

    _pictures.forEach(async (val, i) => {
      const new_album_phot = (await API.graphql(
        // @ts-ignore
        graphqlOperation(createAlbumPhot, {
          input: _addOwnerValue({
            albumID: _albumID,
            photID: val.id,
            albumOrder: i,
          }),
        })
      )) as any;
      _oldAlbumPhots.push(new_album_phot.data.createAlbumPhot);
    });
    setOldAlbumPhots(_oldAlbumPhots);
    setAlbumID(_albumID);
    onChange(_albumID);
  };

  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (!value || typeof value !== "object" || !("id" in value)) return;
    const f = async () => {
      let _res = [];
      for (const phot of value.phots.items) {
        const _image = await API.graphql(
          graphqlOperation(getImage, { id: phot.photID })
        );
        if (!_image.data.getImage) continue;
        _res.push({
          id: _image.data.getImage.id,
          src: _image.data.getImage.url,
          width: 3,
          height: 4,
          order: phot.albumOrder,
          name: _image.data.getImage.alternate,
        });
      }
      _res.sort((x, y) => x.order - y.order);
      // @ts-ignore
      setPictures(_res);
      setOldAlbumPhots(value.phots.items);
      onChange(value.id);
    };
    f();
  }, [value, onChange]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  function handleClickAdd() {
    const _pictures = _uniqPhots([...pictures, ...selectedPhoto]);
    setPictures(_pictures);
    _saveSelectedPhotoToAlbum(_pictures);
    setSelectedPhoto([]);
    setOpen(false);
  }

  function handleClickRemove(targetPhotos) {
    const _pictures = pictures.filter((photo) => {
      return (
        _uniqPhots(targetPhotos).filter((tPhoto) => tPhoto.id === photo.id)
          .length === 0
      );
    });
    setPictures(_pictures);
    _saveSelectedPhotoToAlbum(_pictures);
    setSelectedPhoto([]);
  }

  const handleClose = () => {
    setSelectedPhoto([]);
    setOpen(false);
  };

  const _onSelect = (phots) => {
    setSelectedPhoto(_uniqPhots(phots));
  };

  return (
    <>
      <Alubum
        photos={pictures}
        onChange={(photos) => {
          if (photos.length > 0) {
            photos = _uniqPhots(photos);
            setPictures(photos);
            _saveSelectedPhotoToAlbum(photos);
          }
        }}
        removeFunc={handleClickRemove}
      />
      <Button
        variant="contained"
        color="primary"
        component="div"
        onClick={handleClickOpen}
      >
        {t("Add Photo")}
      </Button>
      <Dialog
        fullWidth
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <ImageManager value={value} onSelect={_onSelect} />

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("Cancel")}
          </Button>
          <Button onClick={handleClickAdd} color="primary">
            {t("Add")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PhotoForm;
